import { IconKind, VisualShape } from 'app/frontend/types/custom/VisualPlan'
import { getIconCanvasFrame } from '../iconKinds'
import { isEncounterGateway } from '../encounterCreatureIcons'

export type IconShape = Extract<VisualShape, { type: 'icon' }>

export type IconStyleCategory = Exclude<IconKind, 'spec'>

export type StyleCategory = IconStyleCategory | 'shape'

export const iconStyleCategory = (kind: IconKind): IconStyleCategory =>
  kind === 'spec' ? 'class' : kind

export const isIconShape = (shape: VisualShape): shape is IconShape =>
  shape.type === 'icon'

export const isFramedIconShape = (shape: VisualShape): shape is IconShape =>
  isIconShape(shape) &&
  getIconCanvasFrame(shape.kind, shape.value) !== undefined

export const isEncounterCreatureShape = (
  shape: VisualShape,
): shape is IconShape =>
  isIconShape(shape) &&
  shape.kind === 'encounter' &&
  !isEncounterGateway(shape.value)

export const hidesDirection = (shape: VisualShape) =>
  isEncounterCreatureShape(shape) && shape.show_direction === false
